import React from 'react';
import bem from '../../../../lib/bemUtils/bem';

type AbbrProps = {
  text: string;
  title: string;
};
export function DownloadAbbr({ text, title }: AbbrProps) {
  return (
    <abbr className={bem('download__abbr')} title={title}>
      {text}
    </abbr>
  );
}
